import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Grid, Button } from '@mui/material';
import AnimateButton from 'ui-component/extended/AnimateButton';
import axios from 'utils/axios';
import { Link, useNavigate } from 'react-router-dom';
import { setIsLoggedIn } from 'store/Authentication/actions';
import { useDispatch } from 'react-redux';
import { googleLoginQuery } from 'utils/apolloQueries';
import FingerPrintHash from 'Components/FingerPrint';
import { getFirebaseToken } from 'Components/Firebase';

export default function GoogleLoginButtonNew(props) {
    const dispatch = useDispatch();
    const { handleFailure, updateLoading, handleChangePage, handleSuccess, disableUserCreation } = props;

    const navigate = useNavigate();
    const [windowDimenion, detectHW] = useState({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight
    });
    const [width, setWidth] = useState(444);
    const detectSize = () => {
        detectHW({
            winWidth: window.innerWidth
        });
    };
    const handleLogin = async (result) => {
        updateLoading(true);
        handleFailure('');
        const id_token = result.credential;
        try {
            let fingerprint = await FingerPrintHash();
            let firebaseToken = null;
            let query = googleLoginQuery;
            let variables = {
                googleToken: {
                    id_token: id_token,
                    fingerprint: fingerprint,
                    firebaseToken: firebaseToken,
                    disableUserCreation: disableUserCreation
                }
            };
            const submitData = { query: query, variables: variables };
            axios({
                method: 'POST',
                data: submitData
            })
                .then(function (response) {
                    if (response.status === 200) {
                        if (response.data.data) {
                            const { accessToken, refreshToken } = response.data.data.loginWithGoogle.userData.token;
                            let googleData = response.data.data.loginWithGoogle.userData.user;
                            if (handleSuccess) {
                                handleSuccess({ email: googleData.email, data: response.data.data.loginWithGoogle });
                                return;
                            }
                            localStorage.setItem('diologAuthToken', accessToken);
                            localStorage.setItem('diologUserData', JSON.stringify(googleData));
                            localStorage.setItem('diologRefToken', refreshToken);
                            dispatch({ type: setIsLoggedIn, isLoggedIn: true });
                            try {
                                let query = 'query Query { userCompanyList { _id } }';
                                const submitData = { query: query };
                                axios({
                                    method: 'POST',
                                    data: submitData,
                                    headers: { Authorization: accessToken }
                                })
                                    .then(function (response) {
                                        if (response.status === 200) {
                                            if (response.data.data) {
                                                let companyId = response.data.data.userCompanyList;
                                                if (companyId.length > 0) {
                                                    googleData.companyId = companyId[0]._id;
                                                    localStorage.setItem('diologUserData', JSON.stringify(googleData));
                                                    handleChangePage('select-company');
                                                    updateLoading(false);
                                                } else {
                                                    handleChangePage('register-company');
                                                    updateLoading(false);
                                                }
                                            } else {
                                                updateLoading(false);
                                                handleFailure('Something went wrong. Please try again later');
                                            }
                                        }
                                    })
                                    .catch(function (response) {
                                        updateLoading(false);
                                        handleFailure('Something went wrong. Please try again later');
                                    });
                            } catch (err) {}
                        } else {
                            localStorage.removeItem('diologAuthToken');
                            localStorage.removeItem('diologUserData');
                            localStorage.removeItem('diologRefToken');
                            updateLoading(false);
                            handleFailure(response.data.errors[0].message);
                        }
                    }
                })
                .catch(function (response) {
                    updateLoading(false);
                    handleFailure('Something went wrong. Please try again later');
                });
        } catch (err) {
            if (scriptedRef.current) {
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
            }
        }
    };
    useEffect(() => {
        window.addEventListener('resize', detectSize);
        return () => {
            window.removeEventListener('resize', detectSize);
        };
    }, [windowDimenion]);

    useEffect(() => {
        let dummy_width = 0;
        if (windowDimenion.winWidth < 576 && windowDimenion.winWidth - 60 < 444) {
            setWidth(props.width ?? windowDimenion.winWidth - 80);
        } else {
            setWidth(props.width ?? 444);
        }
    }, [windowDimenion.winWidth]);

    return (
        <Grid item xs={12} className="google-handler">
            <AnimateButton>
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                    <GoogleLogin
                        onSuccess={(credentialResponse) => {
                            handleLogin(credentialResponse);
                        }}
                        onError={() => {
                            handleFailure('Something went wrong. Please try again later.');
                        }}
                        width={width + 'px'}
                    />
                </GoogleOAuthProvider>
            </AnimateButton>
        </Grid>
    );
}
